export default __webpack_public_path__ + "static/media/zoo1.67cd600b.webp";